// tslint:disable
export var AccountRoleType;
(function (AccountRoleType) {
    // UNKN
    AccountRoleType[AccountRoleType["Unknown"] = 0] = "Unknown";
    // PAT
    AccountRoleType[AccountRoleType["Patient"] = 1] = "Patient";
    // PSRB
    AccountRoleType[AccountRoleType["Prescriber"] = 2] = "Prescriber";
    // INS
    AccountRoleType[AccountRoleType["InsuranceProvider"] = 3] = "InsuranceProvider";
    // PBM
    AccountRoleType[AccountRoleType["PharmacyBenefitManager"] = 4] = "PharmacyBenefitManager";
    // SEC
    AccountRoleType[AccountRoleType["SecondaryContact"] = 5] = "SecondaryContact";
    // MFT
    AccountRoleType[AccountRoleType["Manufacturer"] = 6] = "Manufacturer";
    // EMP
    AccountRoleType[AccountRoleType["EMP"] = 7] = "EMP";
    // CSR
    AccountRoleType[AccountRoleType["CustomerServiceRep"] = 8] = "CustomerServiceRep";
    // PSRBSITE
    AccountRoleType[AccountRoleType["PrescriberSite"] = 9] = "PrescriberSite";
    // BRAND
    AccountRoleType[AccountRoleType["Brand"] = 10] = "Brand";
    // CHLD
    AccountRoleType[AccountRoleType["Child"] = 11] = "Child";
    // SCWRK
    AccountRoleType[AccountRoleType["SocialWorker"] = 12] = "SocialWorker";
    // FINREP
    AccountRoleType[AccountRoleType["FinancialRepresentative"] = 13] = "FinancialRepresentative";
    // LGLREP
    AccountRoleType[AccountRoleType["LegalRepresentative"] = 14] = "LegalRepresentative";
    // COR
    AccountRoleType[AccountRoleType["Corporate"] = 15] = "Corporate";
    // PERCNT
    AccountRoleType[AccountRoleType["PersonalContact"] = 16] = "PersonalContact";
    // SPOUSE
    AccountRoleType[AccountRoleType["Spouse"] = 17] = "Spouse";
    // PARENT
    AccountRoleType[AccountRoleType["Parent"] = 18] = "Parent";
    // HMHEALTH
    AccountRoleType[AccountRoleType["HomeHealth"] = 19] = "HomeHealth";
    // ALTCNT
    AccountRoleType[AccountRoleType["AlternateContact"] = 20] = "AlternateContact";
    // AUTOINJ
    AccountRoleType[AccountRoleType["AutoInjuryPlan"] = 21] = "AutoInjuryPlan";
    // COMMPL
    AccountRoleType[AccountRoleType["CommercialPlan"] = 22] = "CommercialPlan";
    // FEDPL
    AccountRoleType[AccountRoleType["FederalEmployeeProgram"] = 23] = "FederalEmployeeProgram";
    // MEDAD
    AccountRoleType[AccountRoleType["Medicaid"] = 24] = "Medicaid";
    // MDCRAD
    AccountRoleType[AccountRoleType["MedicareAdvantage"] = 25] = "MedicareAdvantage";
    // MDCRB
    AccountRoleType[AccountRoleType["MedicareB"] = 26] = "MedicareB";
    // MDCRD
    AccountRoleType[AccountRoleType["MedicareD"] = 27] = "MedicareD";
    // MDGP
    AccountRoleType[AccountRoleType["MediGap"] = 28] = "MediGap";
    // VATC
    AccountRoleType[AccountRoleType["VADoDTRICARE"] = 29] = "VADoDTRICARE";
    // WRKCMP
    AccountRoleType[AccountRoleType["WorkersCompensation"] = 30] = "WorkersCompensation";
    // PLAN
    AccountRoleType[AccountRoleType["Plan"] = 31] = "Plan";
    // PAYER
    AccountRoleType[AccountRoleType["Payer"] = 32] = "Payer";
    // DMEP
    AccountRoleType[AccountRoleType["DurableMedicalEquiqmentPlan"] = 33] = "DurableMedicalEquiqmentPlan";
    // MCMP
    AccountRoleType[AccountRoleType["ManagedCareMedicaidPlan"] = 34] = "ManagedCareMedicaidPlan";
    // SPAP
    AccountRoleType[AccountRoleType["StatePharmacyAssistanceProgram"] = 35] = "StatePharmacyAssistanceProgram";
    // MEDAB
    AccountRoleType[AccountRoleType["MedicarePartABPlan"] = 36] = "MedicarePartABPlan";
    // ADAP
    AccountRoleType[AccountRoleType["AidsDrugAssistanceProgram"] = 37] = "AidsDrugAssistanceProgram";
    // STPL
    AccountRoleType[AccountRoleType["StatePlan"] = 38] = "StatePlan";
    // PRVD
    AccountRoleType[AccountRoleType["Provider"] = 39] = "Provider";
    // EPO
    AccountRoleType[AccountRoleType["ExclusiveProviderOrganization"] = 40] = "ExclusiveProviderOrganization";
    // INDEM
    AccountRoleType[AccountRoleType["IndemnityInsurance"] = 41] = "IndemnityInsurance";
    // HMO
    AccountRoleType[AccountRoleType["HealthMaintenanceOrganization"] = 42] = "HealthMaintenanceOrganization";
    // POSP
    AccountRoleType[AccountRoleType["PointOfServicePlan"] = 43] = "PointOfServicePlan";
    // PPO
    AccountRoleType[AccountRoleType["PreferredProviderOrganization"] = 44] = "PreferredProviderOrganization";
    // SELF
    AccountRoleType[AccountRoleType["Self"] = 45] = "Self";
    // OFFCNT
    AccountRoleType[AccountRoleType["OfficeContact"] = 46] = "OfficeContact";
    // PHARM
    AccountRoleType[AccountRoleType["Pharmacy"] = 47] = "Pharmacy";
    // MDCRA
    AccountRoleType[AccountRoleType["MedicareA"] = 48] = "MedicareA";
    // HOSP
    AccountRoleType[AccountRoleType["Hospital"] = 49] = "Hospital";
    // HOSPOP
    AccountRoleType[AccountRoleType["HospitalOutpatient"] = 50] = "HospitalOutpatient";
    // INFCTR
    AccountRoleType[AccountRoleType["InfusionCenter"] = 51] = "InfusionCenter";
    // RETPHAR
    AccountRoleType[AccountRoleType["RetailPharmacy"] = 52] = "RetailPharmacy";
    // Foundation
    AccountRoleType[AccountRoleType["Foundation"] = 53] = "Foundation";
    // SecSupp
    AccountRoleType[AccountRoleType["SecondarySupplemental"] = 54] = "SecondarySupplemental";
    // RegNurse
    AccountRoleType[AccountRoleType["RegisteredNurse"] = 55] = "RegisteredNurse";
    // LicPractNurse
    AccountRoleType[AccountRoleType["LicensedPracticalNurse"] = 56] = "LicensedPracticalNurse";
    // CertNursingAsst
    AccountRoleType[AccountRoleType["CertifiedNursingAssistant"] = 57] = "CertifiedNursingAssistant";
    // MedAsst
    AccountRoleType[AccountRoleType["MedicalAssistant"] = 58] = "MedicalAssistant";
    // NatlHealthAgncy
    AccountRoleType[AccountRoleType["NationalHomeHealthAgency"] = 59] = "NationalHomeHealthAgency";
    // IndlHealthAgncy
    AccountRoleType[AccountRoleType["IndependentHomeHealthAgency"] = 60] = "IndependentHomeHealthAgency";
    // Practice
    AccountRoleType[AccountRoleType["Practice"] = 61] = "Practice";
    // PDCI
    AccountRoleType[AccountRoleType["PerDiemContractIndividual"] = 62] = "PerDiemContractIndividual";
    // Employee
    AccountRoleType[AccountRoleType["Employee"] = 63] = "Employee";
})(AccountRoleType || (AccountRoleType = {}));
AccountRoleType['UNKNOWN'] = 0;
AccountRoleType['PATIENT'] = 1;
AccountRoleType['PRESCRIBER'] = 2;
AccountRoleType['INSURANCEPROVIDER'] = 3;
AccountRoleType['PHARMACYBENEFITMANAGER'] = 4;
AccountRoleType['SECONDARYCONTACT'] = 5;
AccountRoleType['MANUFACTURER'] = 6;
AccountRoleType['CUSTOMERSERVICEREP'] = 8;
AccountRoleType['PRESCRIBERSITE'] = 9;
AccountRoleType['BRAND'] = 10;
AccountRoleType['CHILD'] = 11;
AccountRoleType['SOCIALWORKER'] = 12;
AccountRoleType['FINANCIALREPRESENTATIVE'] = 13;
AccountRoleType['LEGALREPRESENTATIVE'] = 14;
AccountRoleType['CORPORATE'] = 15;
AccountRoleType['PERSONALCONTACT'] = 16;
AccountRoleType['SPOUSE'] = 17;
AccountRoleType['PARENT'] = 18;
AccountRoleType['HOMEHEALTH'] = 19;
AccountRoleType['ALTERNATECONTACT'] = 20;
AccountRoleType['AUTOINJURYPLAN'] = 21;
AccountRoleType['COMMERCIALPLAN'] = 22;
AccountRoleType['FEDERALEMPLOYEEPROGRAM'] = 23;
AccountRoleType['MEDICAID'] = 24;
AccountRoleType['MEDICAREADVANTAGE'] = 25;
AccountRoleType['MEDICAREB'] = 26;
AccountRoleType['MEDICARED'] = 27;
AccountRoleType['MEDIGAP'] = 28;
AccountRoleType['VADODTRICARE'] = 29;
AccountRoleType['WORKERSCOMPENSATION'] = 30;
AccountRoleType['PLAN'] = 31;
AccountRoleType['PAYER'] = 32;
AccountRoleType['DURABLEMEDICALEQUIQMENTPLAN'] = 33;
AccountRoleType['MANAGEDCAREMEDICAIDPLAN'] = 34;
AccountRoleType['STATEPHARMACYASSISTANCEPROGRAM'] = 35;
AccountRoleType['MEDICAREPARTABPLAN'] = 36;
AccountRoleType['AIDSDRUGASSISTANCEPROGRAM'] = 37;
AccountRoleType['STATEPLAN'] = 38;
AccountRoleType['PROVIDER'] = 39;
AccountRoleType['EXCLUSIVEPROVIDERORGANIZATION'] = 40;
AccountRoleType['INDEMNITYINSURANCE'] = 41;
AccountRoleType['HEALTHMAINTENANCEORGANIZATION'] = 42;
AccountRoleType['POINTOFSERVICEPLAN'] = 43;
AccountRoleType['PREFERREDPROVIDERORGANIZATION'] = 44;
AccountRoleType['SELF'] = 45;
AccountRoleType['OFFICECONTACT'] = 46;
AccountRoleType['PHARMACY'] = 47;
AccountRoleType['MEDICAREA'] = 48;
AccountRoleType['HOSPITAL'] = 49;
AccountRoleType['HOSPITALOUTPATIENT'] = 50;
AccountRoleType['INFUSIONCENTER'] = 51;
AccountRoleType['RETAILPHARMACY'] = 52;
AccountRoleType['FOUNDATION'] = 53;
AccountRoleType['SECONDARYSUPPLEMENTAL'] = 54;
AccountRoleType['REGISTEREDNURSE'] = 55;
AccountRoleType['LICENSEDPRACTICALNURSE'] = 56;
AccountRoleType['CERTIFIEDNURSINGASSISTANT'] = 57;
AccountRoleType['MEDICALASSISTANT'] = 58;
AccountRoleType['NATIONALHOMEHEALTHAGENCY'] = 59;
AccountRoleType['INDEPENDENTHOMEHEALTHAGENCY'] = 60;
AccountRoleType['PRACTICE'] = 61;
AccountRoleType['PERDIEMCONTRACTINDIVIDUAL'] = 62;
AccountRoleType['EMPLOYEE'] = 63;
//# sourceMappingURL=AccountRoleType.js.map